export const heroSlides = [
  {
    id: "s1",
    image:
      "https://readdy.ai/api/search-image?query=Majestic%20international%20brand%20summit%20stage%20in%20Hong%20Kong%20with%20elegant%20cream%20and%20crimson%20backdrop%2C%20golden%20spotlight%20on%20wooden%20podium%2C%20audience%20silhouettes%20in%20soft%20focus%2C%20cinematic%20warm%20amber%20atmosphere%2C%20editorial%20photojournalism%2C%20refined%20wide%20composition%20with%20subtle%20haze&width=1800&height=900&seq=iabs-hero-01&orientation=landscape",
    title: "世界品牌日．正式落戶香港",
    subtitle: "The 2nd World Brand Conference in Hong Kong",
    caption: "由國際品牌科學院、粵港澳大灣區企業家聯盟及國際品牌網聯合主辦",
  },
  {
    id: "s2",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20Hong%20Kong%20skyline%20at%20golden%20hour%20with%20cream%20and%20amber%20tones%2C%20iconic%20harbour%20view%2C%20refined%20cinematic%20panorama%2C%20soft%20warm%20light%20reflecting%20on%20water%2C%20editorial%20architectural%20photography%2C%20subtle%20mist%20and%20atmospheric%20composition&width=1800&height=900&seq=iabs-hero-02&orientation=landscape",
    title: "香港．世界品牌之都",
    subtitle: "Hong Kong · Capital of World Brands",
    caption: "背靠祖國、聯通世界，構建全球品牌合作與可持續發展的重要平台",
  },
  {
    id: "s3",
    image:
      "https://readdy.ai/api/search-image?query=Distinguished%20international%20delegates%20and%20academic%20scholars%20at%20elegant%20round%20table%20forum%2C%20warm%20golden%20light%2C%20cream%20marble%20interior%2C%20refined%20conference%20setting%2C%20editorial%20photojournalism%20wide%20shot%2C%20focused%20discussion%20with%20subtle%20depth%20of%20field&width=1800&height=900&seq=iabs-hero-03&orientation=landscape",
    title: "品牌價值發展五要素理論",
    subtitle: "Five Elements of Brand Value",
    caption: "品質、服務、技術創新、有形資產、無形資產——構建全球權威品牌評估體系",
  },
];

export const stats = [
  { value: "2022", label: "香港註冊成立", icon: "ri-award-line" },
  { value: "88+", label: "免稅資格認可", icon: "ri-verified-badge-line" },
  { value: "500+", label: "國際品牌合作", icon: "ri-global-line" },
  { value: "30", label: "國家與地區覆蓋", icon: "ri-earth-line" },
];

export const rankings = [
  {
    id: "r1",
    title: "2025 中國品牌國際化標桿 100 強",
    year: "2025",
    desc: "評估中國品牌走向全球市場的綜合能力，涵蓋技術、渠道、文化影響力等維度。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20golden%20trophy%20on%20cream%20marble%20pedestal%20with%20warm%20amber%20lighting%2C%20refined%20award%20ceremony%20still%20life%2C%20subtle%20burgundy%20ribbon%20drape%2C%20luxury%20editorial%20photography%20with%20soft%20natural%20shadows%20and%20minimal%20composition&width=900&height=600&seq=iabs-rank-01&orientation=landscape",
    link: "#",
  },
  {
    id: "r2",
    title: "世界稻米產區三十強",
    year: "2024",
    desc: "全球稻米核心產區的品牌強度評估，覆蓋亞洲、美洲及非洲主要產區。",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20rice%20grains%20artistically%20arranged%20on%20cream%20linen%20cloth%20with%20warm%20natural%20window%20light%2C%20refined%20editorial%20food%20photography%2C%20subtle%20amber%20tones%2C%20minimalist%20composition%20with%20soft%20shadows%20and%20texture%20detail&width=900&height=600&seq=iabs-rank-02&orientation=landscape",
    link: "https://www.chinanationalbrand.org.cn/article/news/detail/id/42682",
  },
  {
    id: "r3",
    title: "世界紡織服飾品牌強度評估",
    year: "2024",
    desc: "紡織服飾行業品牌強度與國際競爭力綜合評估，行業權威參考指標。",
    image:
      "https://readdy.ai/api/search-image?query=Luxurious%20folded%20textile%20fabrics%20in%20cream%20burgundy%20and%20gold%20on%20warm%20wooden%20surface%2C%20elegant%20editorial%20still%20life%2C%20soft%20diffused%20window%20light%2C%20refined%20composition%20with%20subtle%20texture%20and%20warm%20natural%20shadows&width=900&height=600&seq=iabs-rank-03&orientation=landscape",
    link: "https://www.chinanationalbrand.org.cn/article/news/detail/action/news/id/42672",
  },
];

export const partners = [
  "華僑大學國際品牌研究院",
  "粵港澳大灣區企業家聯盟",
  "國際品牌網",
  "國際稻香米品牌中心",
  "中國國家品牌網",
  "香港貿易發展局",
  "新華社",
  "香港商報",
];